import { render } from "./ReservasiUser.vue?vue&type=template&id=0b3196e0"
import script from "./ReservasiUser.vue?vue&type=script&lang=js"
export * from "./ReservasiUser.vue?vue&type=script&lang=js"

import "./ReservasiUser.vue?vue&type=style&index=0&id=0b3196e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__